module.exports = __webpack_public_path__ + "img/googleplay-badge.eedcb9a0.png";